export default __webpack_public_path__ + "assets/99efed2869d96be4a7ad68551b161223.webp";